
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-serialization-demo-serialization-tojson"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/serialization.en.md?type=demo')
};